import React, { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router";
import CenteredContainer from "../../../../shared/components/CenteredContainer";
import LoadingScreen from "../../../../shared/components/Loading";
import { isAuthenticated, isAuthenticating } from "../../redux/slice";
import { getCookie } from "../../../../utils/cookieUtils";
import useTranslation from "../../../../shared/hooks/useTranslation";

const LoginScreen = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const authenticated = useSelector(isAuthenticated);
    const authenticating = useSelector(isAuthenticating);

    const csrfToken = useMemo(
        () =>
            getCookie("XSRF-TOKEN") ||
            document.querySelector('meta[name="csrf-token"]')?.getAttribute("content"),
        [],
    );

    const error = useMemo(
        () => new URLSearchParams(location.search).get("error"),
        [location.search],
    );

    if (authenticating) return <LoadingScreen />;

    if (authenticated) return <Navigate to="/" replace />;

    return (
        <CenteredContainer>
            <div className="relative w-full max-w-sm rounded-card border border-border bg-surface px-8 pb-8 pt-16 shadow-lg">
                <div className="absolute left-1/2 top-0 flex h-20 w-20 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-2xl bg-accent text-4xl font-extrabold text-white shadow-lg">
                    A
                </div>
                {error && (
                    <div className="mb-4 flex items-start gap-2 rounded-card border border-danger/40 bg-red-50 px-3 py-2 text-sm text-danger">
                        <FontAwesomeIcon icon={faTriangleExclamation} className="mt-0.5" />
                        <span>{t(`errors.messages.${error}`)}</span>
                    </div>
                )}
                <form action="/users/auth/uol_identity" method="post">
                    {csrfToken && (
                        <input type="hidden" name="authenticity_token" value={csrfToken} />
                    )}
                    <button
                        type="submit"
                        className="flex w-full cursor-pointer appearance-none items-center justify-center gap-2 rounded-lg! border-0 bg-accent px-4 py-2.5 text-sm font-medium text-white! transition-colors hover:brightness-110"
                    >
                        {t("auth.login.uol_identity.title")}
                    </button>
                </form>
            </div>
        </CenteredContainer>
    );
};

export default LoginScreen;
